import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

export default function TopicsSection() {
  return (
    <section id="topics" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label font-medium tracking-[0.2em] uppercase text-primary-600">
              <i className="ri-links-line" aria-hidden="true" />
              专题分类
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              跨越频道的横向聚合，按主题读得更深
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              同一个议题往往横跨多个频道。专题分类把相关报道、调查与案例聚在一起，方便你顺着一条线索读到底。
            </p>
          </div>
          <Link
            to="/topics"
            className="inline-flex w-fit items-center gap-2 border border-foreground-950/15 hover:border-primary-400 hover:text-primary-600 text-foreground-800 font-label text-sm px-5 py-2.5 rounded-md transition-colors whitespace-nowrap"
          >
            进入专题分类
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {topics.map((topic, index) => (
            <Link
              key={topic.slug}
              to="/topics"
              className={`group relative flex flex-col overflow-hidden rounded-lg border border-background-300/60 bg-background-100/50 transition-colors hover:border-primary-300 ${
                index === 0 ? 'md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              <div className="w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={topic.image}
                  alt={`${topic.name} 专题配图`}
                  title={`${topic.name} - 爆料官网专题分类`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col gap-3 p-5 md:p-6">
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 rounded-lg bg-accent-100 text-accent-800 flex items-center justify-center">
                    <i className={`${topic.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{topic.name}</h3>
                </div>
                <p className="text-sm leading-relaxed text-foreground-600">{topic.desc}</p>
                <div className="flex flex-wrap gap-2 pt-1">
                  {topic.keywords.map((k) => (
                    <span key={k} className="text-xs font-label px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900">
                      {k}
                    </span>
                  ))}
                </div>
                <div className="mt-2 pt-3 border-t border-background-300/60 flex items-center justify-between text-xs font-label text-foreground-500">
                  <span>收录 {topic.count} 篇</span>
                  <span className="inline-flex items-center gap-1 text-primary-600 group-hover:text-primary-700 transition-colors">
                    查看专题
                    <i className="ri-arrow-right-s-line" aria-hidden="true" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}